import React from 'react';
import Container from '../grid/Container';
import { breakpoints, color, font } from '../../styles/theme';

const whyItems = [
  {
    icon: '💰',
    title: 'Edullisia golfmatkoja',
    text: 'Majoitus, kuljetukset green feet ja kaikki tarvittava samassa helpossa paketissa.'
  },
  {
    icon: '⏱️',
    title: '2–3 yön reissuja',
    text: 'Ehdit golfmatkalle helposti vaikka viikonlopuksi.'
  },
  {
    icon: '🚌',
    title: 'Me kyyditsemme golf bägit',
    text: 'IMT.fi -bussit ovat apunasi. Voit myös valita matkan omalla autolla.'
  },
  {
    icon: '🤝',
    title: 'Luotettava matkanjärjestäjä',
    text: 'Matkat on rakennettu yhteistyössä Viron golfkenttien ja Tallinkin kanssa. IMT.fi on vastuullinen matkanjärjestäjä.'
  }
];

const WhyGolf: React.FC = () => {
  return (
    <div className="why-section">
      <Container>
        <div className="section-header">
          <h2 className="section-title">Miksi lähteä golfmatkalle?</h2>
        </div>
        <div className="why-grid">
          {whyItems.map((item, index) => (
            <div key={index} className="why-card">
              <div className="why-card-header">
                <span className="why-icon">{item.icon}</span>
                <h3 className="why-title">{item.title}</h3>
              </div>
              <p className="why-text">{item.text}</p>
            </div>
          ))}
        </div>
      </Container>
      {/*language=CSS*/}
      <style jsx>{`
        .why-section {
          padding: 80px 0 100px;
          background: ${color.white};
        }

        .section-header {
          text-align: center;
          margin-bottom: 56px;
        }

        .section-title {
          font-family: ${font.primary};
          font-size: 2.5rem;
          font-weight: 700;
          color: ${color.dark};
          margin: 0;
        }

        .why-grid {
          display: grid;
          grid-template-columns: 1fr;
          gap: 24px;
        }

        .why-card {
          background: ${color.lightBackground};
          border-radius: 16px;
          padding: 36px 28px;
          transition: all 0.3s ease;
        }

        .why-card:hover {
          transform: translateY(-4px);
          box-shadow: 0 8px 30px rgba(0, 0, 0, 0.08);
        }

        .why-card-header {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-bottom: 10px;
        }

        .why-icon {
          font-size: 1.75rem;
          flex-shrink: 0;
          line-height: 1;
        }

        .why-title {
          font-family: ${font.primary};
          font-size: 1.15rem;
          font-weight: 700;
          color: ${color.dark};
          margin: 0;
          line-height: 1.3;
        }

        .why-text {
          font-family: ${font.primary};
          font-size: 1rem;
          color: ${color.gray};
          margin: 0;
          line-height: 1.6;
        }

        @media ${breakpoints.medium} {
          .why-grid {
            grid-template-columns: repeat(2, 1fr);
            gap: 28px;
          }
        }
      `}</style>
    </div>
  );
};

export default WhyGolf;
